import { useState } from "react";
import { IconPlus, IconMinus } from "@tabler/icons-react";
import { useSearchParams } from "react-router-dom";
import RoleToggle from "../../../components/RoleToggle";
import TireListTab from "./TireListTab";
import PriceTab from "./PriceTab";

export default function PriceMatrix() {
  const roles = ["Price", "Tier"];
  const [searchParams, setSearchParams] = useSearchParams();
  const activeRole = searchParams.get("sub") || "Price";
  const currentTab = searchParams.get("tab") || "Price Matrix";
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen1, setIsModalOpen1] = useState(false);

  const [priceResetKey, setPriceResetKey] = useState(0);
  const [tierResetKey, setTierResetKey] = useState(0);

  const handlePriceMinus = () => {
    setIsModalOpen1(false);
    setPriceResetKey((k) => k + 1);
  };

  const handleTierMinus = () => {
    setIsModalOpen(false);
    setTierResetKey((k) => k + 1);
  };

  const handleRoleChange = (role: string) => {
    setSearchParams({ tab: currentTab, sub: role });
    setIsModalOpen(false);
  };

  const handleToggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };
  const handleToggleModal1 = () => {
    setIsModalOpen1((prev) => !prev);
  };

  return (
    <div className="space-y-4 border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5] mb-4">
      <div className="flex justify-between items-center">
        <RoleToggle
          options={roles}
          active={activeRole}
          onChange={handleRoleChange}
        />

        {activeRole === "Tier" && (
          <button
            onClick={isModalOpen ? handleTierMinus : handleToggleModal}
            className="bg-[#FBD037] text-[#212121] p-2 rounded-full"
          >
            {isModalOpen ? (
              <IconMinus stroke={1.5} size={20} />
            ) : (
              <IconPlus stroke={1.5} size={20} />
            )}
          </button>
        )}

        {activeRole === "Price" && (
          <button
            onClick={isModalOpen1 ? handlePriceMinus : handleToggleModal1}
            className="bg-[#FBD037] text-[#212121] p-2 rounded-full"
          >
            {isModalOpen1 ? (
              <IconMinus stroke={1.5} size={20} />
            ) : (
              <IconPlus stroke={1.5} size={20} />
            )}
          </button>
        )}
      </div>

      {activeRole === "Price" && (
        <PriceTab
          key={priceResetKey}
          isOpen={isModalOpen1}
          onClose={() => setIsModalOpen1(false)}
          onToggle={() => setIsModalOpen1(true)}
        />
      )}
      {activeRole === "Tier" && (
        <TireListTab
          key={tierResetKey}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onToggle={() => setIsModalOpen(true)}
        />
      )}
    </div>
  );
}
